import React, { useState, useEffect, useRef, useMemo } from "react";
import { DeleteWorkRequirement } from "screens/Requests/logic/DeleteWorkRequirement";
import { GetService } from "screens/Services/logic/GetService";
import { debounce } from "lodash";
import { saveWorkRequirementService } from "screens/Requests/logic/SaveWorkRequirementService";
import { GetWorkReqService } from "screens/Requests/logic/GetWorkRequirement";
import { GetPropertyArea } from "screens/Customers/logic/GetPropertyArea";
import { DeleteAttachment } from "components/logic/DeleteAttachment";
import { GetAttachments } from "components/logic/GetAttachments";
import { SaveAttachments } from "components/logic/SaveAttachments";
import { saveAs } from 'file-saver';
import { DownloadAttachments } from "components/logic/DownloadAttachments";
import { GetBundle } from "screens/Services/logic/GetBundle";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import _ from "lodash";
import { GetBudgetedSummary } from "screens/Assessments/logic/GetBudgettedSummary";
import {useTheme} from '@mui/material/styles';

export const useWorkRequirementLogic = ({requestID, navigate,toast, setLoading, serviceRequest, entity = null}) => {

    //#region States
  // Determine if this flow allows duplicate services (WorkOrder and Estimate)
  // Assessment flows (entity = null) will use sync behavior (prevent duplicates)
  const isAllowDuplicatesFlow = 
    entity === 'workOrder-create' || 
    entity === 'workOrder-detail' || 
    entity === 'estimate-create' || 
    entity === 'estimate-detail';
  const initialWorkRequirement = {
    "workReqID": 0,
    "entityID": requestID || 0,
    "subServiceID": 0,
    "bundleID": 0,
    "propertyAreaIDs": [
      0
    ],
    "description": null,
    "specialInstructions": [],
    "jobs": [
      {
        "jobID": 0,
        "flatRate": 0,
        "billingType": "",
        "occurrenceNo": 0,
        "scheduleStart": null,
        "scheduleEnd": null,
        "scheduleMethod": null,
        "reminder": null,
        "reminderTime": null,
        "assignees": null,
        "status": 'Unscheduled'
      }
    ],
    "jobType": null,
    "billingType": null,
    "frequency": null,
    "numberOfOccurrences": null,
    "firstOccurrenceDate": null,
    "excludeWeekends": null,
    "excludeHolidays": null,
    "daysOfWeek": [
      0
    ],
    "weekConfiguration": null,
    "monthConfiguration": [
      0
    ],
    "intervalDays": null
  };
  const [workRequirement, setWorkRequirement] = useState(initialWorkRequirement);
  
  const [openServiceDlg, setOpenServiceDlg] = useState(false);
  
  const MySwal = withReactContent(Swal);
  
  const [openBundleDlg, setOpenBundleDlg] = useState(false);
  const [workRequirementErrors, setWorkRequirementErrors] = useState({});
  const [workRequirementList, setWorkRequirementList] = useState([]);  
  const [oldWorkRequirementList, setOldWorkRequirementList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [bundleList, setBundleList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const currentPageRef = useRef(1);
  const [pageSize, setPageSize] = useState(25);
  const [hasMore, setHasMore] = useState(true);
  const [count, setCount] = useState(26);
  const [loadingRecords, setLoadingRecords] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [localSearch, setLocalSearch] = useState("");
  
  const fetchLock = useRef(false);
  const serviceListRef = useRef([]);
  const bundleListRef = useRef([]);
  const popoverContentRef = useRef(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedBundles, setSelectedBundles] = useState([]);
  const [serviceContent, setServiceContent] = useState({
    title: "Add Service",
    notification: "Service added successfully.",
    deleteNotification: "Service deleted successfully.",
    deleteTitle: "Delete Service",
    deleteMessage: "Are you sure you want to delete this service?",
  });  
  const [lineItemTotal, setLineItemTotal] = useState({
    Price: 0,
    Cost: 0,
    Profit: 0,
    ManHrs: 0,
  });

  const [lineItemList, setLineItem] = useState({
    Price: 0,
    Cost: 0,
    Profit: 0,
    ManHrs: 0,
  });
  
  // Reusable toast configuration
  const toastOptions = {
    position: "top-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light"
  };
const theme = useTheme();
  const [newInstruction, setNewInstruction] = useState("");
  const [updatedWorkReqID, setUpdatedWorkReqID] = useState(null);
  const [pendingUpdate, setPendingUpdate] = useState(false);
  const savingRef = useRef(false);
  const [PropertyAreas, setPropertyAreas] = useState([]);

  //WR Attachments
  const [openWRUploadDlg, setWROpenUploadDlg] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [f, sf] = useState([]);
  const [attachmentMap, setAttachmentMap] = useState({});
  const [currentWorkReqID, setCurrentWorkReqID] = useState(0);
  const [isAttachmentDlgClosed, setIsAttachmentDlgClosed] = useState(false);
  const [openService, setOpenService] = useState(false);
  const [openBundle, setOpenBundle] = useState(false);
  const [description, setDescription] = useState("");


  //BudgettedSummary
  const [budgettedSummary, setBudgettedSummary] = useState({
    price: 0,
    cost: 0,
    profit: 0,
    manHrs: 0,
  });

  // const [budgettedSummaryService, setBudgettedSummaryService] = useState({
  //   price: 0,
  //   cost: 0,
  //   profit: 0,
  //   manHrs: 0,
  // });

  const [budgettedSummaryService, setBudgettedSummaryService] = useState([]);

  const [budgettedSummaryBundle, setBudgettedSummaryBundle] = useState({
    price: 0,
    cost: 0,
    profit: 0,
    manHrs: 0,
  });


  //#endregion states

  //#region handlers    

  const handleOpenServiceDlg = () => setOpenServiceDlg(true);
  const handleCloseServiceDlg = () => {
    setOpenServiceDlg(false);
    handleClearSearch();
  };
  
  const handleOpenBundleDlg = () => setOpenBundleDlg(true);
  const handleCloseBundleDlg = () => setOpenBundleDlg(false);

  const handleCloseWRUploadDlg = () => {
    setUploadFiles([]);
    setWROpenUploadDlg(false);    
    setIsAttachmentDlgClosed(true);
  };

  const handleOpenWorkRequirementUploadDlg = (workReqID) => {
    setWROpenUploadDlg(true);     
    setCurrentWorkReqID(workReqID);       
  };

  useEffect(() => {
    if (currentWorkReqID > 0 && isAttachmentDlgClosed && f.length > 0) {
      handleUploadAttachment(currentWorkReqID); 
      setCurrentWorkReqID(0);
      setIsAttachmentDlgClosed(false);  
    }
  },[isAttachmentDlgClosed]);
  //End 

  const fetchPropertyAreas = async () => {
    try {
      const result = await GetPropertyArea(serviceRequest?.jobSiteID, 0, navigate);
      // console.log("propertyArea")
      // console.log(result)
      setPropertyAreas(result);
    } catch (error) {
      console.error("Error fetching property area:", error);
    }
  };

  const handleAddInstruction = (workReqID, index) => {
    if (!newInstruction[index]?.trim()) return;
  
    setWorkRequirementList((prevList) => {
      const updatedList = prevList.map((item) => {
        if (item.workReqID === workReqID) {
          const updatedItem = {
            ...item,
            specialInstructions: [
              ...(item.specialInstructions || []),
              {
                specialInstructionID: 0,
                instructionText: newInstruction[index],
                isAlert: true,
              },
            ],
          };
          // console.log("✅ Updated Item:", updatedItem);
          return updatedItem;
        }
        return item;
      });
  
      // console.log("✅ Updated List:", updatedList);
      return updatedList;
    });
  
    setNewInstruction((prev) => ({        
      ...prev,
      [index]: "",
    }));
    setUpdatedWorkReqID(workReqID);
  };

  const safeParseFirstAreaID = (areaIDs) => {
    try {      
      const parsedAreaIDs = typeof areaIDs === "string" ? JSON.parse(areaIDs) : Array.isArray(areaIDs)
      ? areaIDs : [] ;
      return parsedAreaIDs;      
    } catch {
      console.log('error');
      return [];
    }
  };
  
  // const handleWorkRequirementChange = (workReqID, field, value) => {
  //   if(field === 'description')    
  //   if(value.trim() === (oldWorkRequirementList.filter(x => x.workReqID === workReqID)[0].description) || value.trim() === "") return; // Prevent unchanged description{
  //   if(field === 'propertyAreaIDs')
  //   if(safeParseFirstAreaID(oldWorkRequirementList.filter(x => x.workReqID === workReqID)[0].propertyAreaIDs, workReqID).length === value.length && _.isEqual(safeParseFirstAreaID(oldWorkRequirementList.filter(x => x.workReqID === workReqID)[0].propertyAreaIDs, workReqID),value)) return; // Prevent unchanged property area      
  //   setWorkRequirementList((prevList) =>
  //     prevList.map((item) =>
  //       item.workReqID === workReqID ? { ...item, [field]: value } : item
  //     )
  //   );    
  //   setUpdatedWorkReqID(workReqID);
  // };
  const handleWorkRequirementChange = (workReqID, field, value) => {
    setWorkRequirementList(prev =>
      prev.map(item => {
        if (item.workReqID !== workReqID) return item;
  
        const updated = { ...item, [field]: value };
  
        if (field === "jobType") {
          if (value === "Recurring") {
            // if they switch *into* Recurring, default to 1 instead of 0
            updated.numberOfOccurrences = item.numberOfOccurrences ?? 1;
          } else {
            // switching out of Recurring – but keep it at 1 so it’s never zero
            updated.numberOfOccurrences = 1;
          }
        }
  
        return updated;
      })
    );
    setUpdatedWorkReqID(workReqID);
  };
    

  const handleChange = (workReqID, field, value) => {    
    setWorkRequirementList((prevList) =>
      prevList.map((item) =>
        item.workReqID === workReqID ? { ...item, [field]: value } : item
      )
    );    
  };
  
  // useEffect(() => {
  //   if (updatedWorkReqID !== null) {
  //     UpdateWorkRequirement(updatedWorkReqID);
  //     setUpdatedWorkReqID(null); // Reset after processing
  //   }
  // }, [updatedWorkReqID]);

  useEffect(() => {
    if (updatedWorkReqID === null) return;
  
    const workReq = workRequirementList.find(w => w.workReqID === updatedWorkReqID);
    if (!workReq) {
      setUpdatedWorkReqID(null);
      return;
    }
  
    if (workReq.jobType === "Recurring") {
      if (!workReq.numberOfOccurrences || workReq.numberOfOccurrences <= 0) {
        return; // wait until user supplies valid occurrences
      }
    }
  
    UpdateWorkRequirement(updatedWorkReqID);
    setUpdatedWorkReqID(null);
  }, [updatedWorkReqID, workRequirementList]);  

  const handleToggleAlert = (workReqID, instructionIndex) => {
    setWorkRequirementList((prevList) =>
      prevList.map((item) =>
        item.workReqID === workReqID
          ? {
              ...item,
              specialInstructions: item.specialInstructions.map((instruction, idx) =>
                idx === instructionIndex
                  ? { ...instruction, isAlert: !instruction.isAlert }
                  : instruction
              ),
            }
          : item
      )
    );
    setUpdatedWorkReqID(workReqID);
  };

  const handleRemoveInstruction = (workReqID, instructionIndex) => {
    setWorkRequirementList((prevList) =>
      prevList.map((item) =>
        item.workReqID === workReqID
          ? {
              ...item,
              specialInstructions: item.specialInstructions.filter(
                (_, idx) => idx !== instructionIndex
              ),
            }
          : item
      )
    );
    setUpdatedWorkReqID(workReqID);
  };

  const handleWorkRequirementDelete = async (workReqID) => {
    try{
      const result = await DeleteWorkRequirement(workReqID,requestID,navigate);
      if (result && !result.isError) {
        fetchWorkRequirements(requestID);
        toast.success("Work Requirement deleted successfully.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      } else {
        toast.error("Cannot delete Services that have been Invoiced", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      }
    }catch(error){
      console.error("Error deleting work requirement:", error);
    } 
  };

  const handleWorkRequirementBundleDelete = async (workReqID, bundleID) => {
    try {
      // Get all work requirements for the bundle
      console.log(workRequirementList)
      const bundleWorkReqs = workRequirementList.filter(x => x.bundleID === bundleID);
      
      if (!bundleWorkReqs.length) {
        toast.error("No work requirements found for this bundle.", toastOptions);
        return;
      }
  
      // Create array of delete promises
      const deletePromises = bundleWorkReqs.map(req => 
        DeleteWorkRequirement(req.workReqID, requestID, navigate)
      );
  
      // Execute all deletes in parallel
      const results = await Promise.all(deletePromises);
  
      // Check if any deletion failed
      const hasErrors = results.some(result => result?.isError);
      
      if (!hasErrors) {
        await fetchWorkRequirements(requestID);
        // toast.success(
        //   `Deleted ${results.length} work requirement${results.length > 1 ? 's' : ''} successfully.`,
        //   { ...toastOptions, autoClose: 3000 }
        // );
      } else {
        const errorCount = results.filter(r => r?.isError).length;
        toast.error(
          `Failed to delete ${errorCount} of ${results.length} requirements.`,
          { ...toastOptions, autoClose: 5000 }
        );
      }
    } catch (error) {
      console.error("Error deleting work requirements:", error);
      toast.error(
        "An unexpected error occurred during deletion.",
        { ...toastOptions, autoClose: 5000 }
      );
    }
  };

  const handleServiceFromBundleDelete = async (workReqID, bundleID) => {
    try {
      // Count services in this bundle
      const servicesInBundle = workRequirementList.filter(x => x.bundleID === bundleID);
      
      if (servicesInBundle.length === 1) {
        // Last service - delete entire bundle (but show service deletion message)
        const result = await DeleteWorkRequirement(workReqID, requestID, navigate);
        if (result && !result.isError) {
          fetchWorkRequirements(requestID);
          ResetServicesAndBundlesCollapse();
          toast.success("Work Requirement deleted successfully.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            style: {
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '15px',
            },
          });
        } else {
          toast.error("Cannot delete Services that have been Invoiced", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            style: {
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '15px',
            },
          });
        }
      } else {
        // Multiple services - delete just this one
        await handleWorkRequirementDelete(workReqID);
      }
    } catch (error) {
      console.error("Error deleting service from bundle:", error);
    }
  };

  const showConfirmationWorkRequirementDelete = (workReqID, isBundle = false, bundleID = null) => {
    MySwal.fire({
      title: '<strong>Are you sure?</strong>',
      html: isBundle 
        ? '<span>Bundle exclusive price will not be considered. You won\'t be able to revert this!</span>'
        : '<span>You won\'t be able to revert this</span>',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
      width: '450px',
      padding: '1rem',
      focusConfirm: false,
      showCloseButton: true,
      closeButtonHtml: '&times;',
      customClass: {
        popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
        title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
        htmlContainer: 'custom-swal-html',
        confirmButton: 'custom-swal-confirm',
        cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
        closeButton: 'custom-swal-close'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        if (isBundle && bundleID) {
          handleServiceFromBundleDelete(workReqID, bundleID);
        } else {
          handleWorkRequirementDelete(workReqID);
        }
      }
    });
}

  const showConfirmationBundleDelete = (bundle) => {
    MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: '<span>If you delete this bundle, all the Services in this Bundle will revert to standard pricing.</span>',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
     width: '420px', 
     padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', 
     customClass: {
     popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
  }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const deletePromises = bundle.services.map(service =>
            DeleteWorkRequirement(service.workReqID, requestID, navigate)
          );
  
          const results = await Promise.all(deletePromises);
  
          const anyFailed = results.some(res => res?.isError);
          fetchWorkRequirements(requestID);
  
          if (anyFailed) {
            toast.error("Some services failed to delete.", {
              position: "top-right",
              autoClose: 5000,
                theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
          } else {
            toast.success("Bundle removed successfully.", {
              position: "top-right",
              autoClose: 3000,
               theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
          }
        } catch (error) {
          console.error("Error deleting bundle:", error);
          toast.error("Failed to delete the bundle.", {
            position: "top-right",
            autoClose: 5000,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      }
    });
  };

  const fetchServices = async (reset = false) => {
    if ((count <= serviceList.length && !reset) || loadingRecords || fetchLock.current) return;

    fetchLock.current = true;
    setLoadingRecords(true);

    try {
      const pageToFetch = reset ? 1 : currentPageRef.current;
      //console.log("Fetching with search text:", localSearch);
      
      const data = await GetService(0, pageSize, pageToFetch, localSearch, navigate);

      if (data?.result?.length > 0) {
        const filteredData = data.result.map(item => ({
          ...item,
          isSelected: selectedServices.some(s => s.serviceOfferingID === item.serviceOfferingID),
        }));

        const allServices = reset
        ? [...selectedServices, ...filteredData]
        : [...selectedServices, ...serviceListRef.current, ...filteredData];

        // Remove duplicates by serviceOfferingID
        const uniqueServices = Array.from(
          new Map(allServices.map(item => [item.serviceOfferingID, item])).values()
        );

        serviceListRef.current = uniqueServices;

        if (reset) {
          serviceListRef.current = filteredData;
          currentPageRef.current = 2;
        } else {
          serviceListRef.current = [...serviceListRef.current, ...filteredData];
          currentPageRef.current += 1;
        }
        setServiceList([...uniqueServices]);
        setCount(data.result[0].TotalCount);
      } else {
        setCount(0);
        if (reset) {
          serviceListRef.current = [...selectedServices];
          setServiceList([...selectedServices]);
        }
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoadingRecords(false);
      fetchLock.current = false;
    }
  };

  const fetchBundles = async () => {    
    fetchLock.current = true;
    setLoadingRecords(true);
    try {
      const data = await GetBundle(0, navigate);

      if (data?.result?.length > 0) {
        const filteredData = data.result.map(item => ({
          ...item,
          isSelected: selectedBundles.some(s => s.bundleID === item.bundleID),
        }));

        const allBundles = [...selectedBundles, ...filteredData];

        const uniqueBundles = Array.from(
          new Map(allBundles.map(item => [item.bundleID, item])).values()
        );
        
        setBundleList(uniqueBundles);      
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoadingRecords(false);
      fetchLock.current = false;
    }
  };

  const fetchWorkRequirements = async (requestID_New) => {
    const requestID = requestID_New === null ? serviceRequest?.requestID : requestID_New;
    // console.log("RID="+requestID)
    try {
      const data = await GetWorkReqService(requestID,0, navigate);
      if (data.length > 0) {
        setWorkRequirementList(data); 
        setOldWorkRequirementList(data);
        const mappedServices = data.filter(x => x.bundleID === 0 && x.subServiceID > 0).map(item => ({
          serviceOfferingID: item.subServiceID,
          serviceOfferingName: item.subServiceName,
          industryName: item.industryName,
          label: `${item.industryName} - ${item.subServiceName}`,
        }));

        const mappedBundles = data
          .filter(x => x.bundleID > 0)
          .reduce((acc, item) => {
            // Check if bundle already exists
            const existingBundle = acc.find(b => b.bundleID === item.bundleID);

            if (existingBundle) {
              // Add service to existing bundle
              existingBundle.services.push({
                serviceOfferingID: item.subServiceID,
                serviceOfferingName: item.subServiceName,
                industryName: item.industryName,
                label: `${item.industryName} - ${item.subServiceName}`,
              });
            } else {
              // Create new bundle entry
              acc.push({
                bundleID: item.bundleID,
                label: item.bundleName || `Bundle ${item.bundleID}`, // Handle null bundleName
                bundleName: item.bundleName,
                services: [{
                  serviceOfferingID: item.subServiceID,
                  serviceOfferingName: item.subServiceName,
                  industryName: item.industryName,
                  label: `${item.industryName} - ${item.subServiceName}`,
                }]
              });
            }
            return acc;
          }, []);
  
        // Services: For WorkOrder/Estimate flows (create & detail), don't pre-select to allow duplicates
        //           For Assessment flows, pre-select to show what's already added (prevent duplicates)
        // Bundles: ALWAYS pre-select for all flows (bundles cannot be duplicated - they're templates)
        if (isAllowDuplicatesFlow) {
          setSelectedServices([]); // WorkOrder/Estimate: Start fresh, allow adding duplicate services
        } else {
          setSelectedServices(mappedServices); // Assessment: Show existing services, prevent duplicates
        }
        
        // Bundles: Always pre-select to prevent duplicates in ALL flows
        setSelectedBundles(mappedBundles);       
      }
      else {
        setWorkRequirementList([]);
        setOldWorkRequirementList([]);
        setSelectedServices([]);
        setSelectedBundles([]);
      }      
    } catch (error) {
      console.error("Error fetching work requirements:", error);
    }
  };

  const UpdateWorkRequirement = async (workReqID) => {       
    const getWorkReq = workRequirementList.find(item => item.workReqID === workReqID);
    if (!getWorkReq) return;
  
    setWorkRequirement(getWorkReq);
    setPendingUpdate(true);                   
  }

  // const debouncedSaveData = useRef(
  //   debounce(async () => {
  //     if (savingRef.current || !pendingUpdate) return;
  
  //     savingRef.current = true;
  //     try {
  //       setLoading(true);
  //       const result = await saveWorkRequirement(
  //         workRequirement.subServiceID,
  //         workRequirement.bundleID
  //       );
  //       toast.success("Work Requirement updated successfully.");
  //     } catch (error) {
  //       toast.error("An unexpected error occurred.");
  //     } finally {
  //       savingRef.current = false;
  //       setPendingUpdate(false);
  //       setLoading(false);
  //     }
  //   }, 500)
  // ).current;
  
  // useEffect(() => {
  //   if (pendingUpdate) {
  //     debouncedSaveData();
  //   }
  // }, [pendingUpdate]);
  
  useEffect(() => {
    const saveData = debounce(async () => {      
      if (pendingUpdate && !savingRef.current) {
        savingRef.current = true;
        try { 
          setLoading(true) ;         
          const result = await saveWorkRequirement(workRequirement.subServiceID, workRequirement.bundleID);          
          toast.success("Work Requirement updated successfully.", {
        style: {
          fontFamily: "'DM Sans', sans-serif",
        },
      });            
        } catch (error) {
          toast.error("An unexpected error occurred.");
        } finally {
          savingRef.current = false;
          setPendingUpdate(false);
          setLoading(false);
        }
      }
    }, 500);   
    saveData();
  }, [pendingUpdate]);

  const saveWorkRequirement = async (serviceID, bundleID) => {
    try{
      setLoading(true) ;
      setWorkRequirement((prevState) => ({
        ...prevState,
        subServiceID: serviceID,
        bundleID : bundleID
      }));
      const result = await saveWorkRequirementService(workRequirement, requestID, serviceID, bundleID, navigate);      
    }catch(error){
      console.error("Error saving work requirement:", error);
    }finally{
      fetchWorkRequirements(requestID);
      // setWorkRequirement({initialWorkRequirement});
      setWorkRequirement(initialWorkRequirement);
      setLoading(false);
    }
  }
  const saveWorkRequirementBundle = async (bundleData) => {    
      try {
        // Create all service promises first using the passed bundle data
        const servicePromises = bundleData.services.map(service => {
          const updatedRequirement = {
            ...workRequirement, // Copy existing state
            subServiceID: service.serviceOfferingID,
            bundleID: bundleData.bundleID
          };
  
          return saveWorkRequirementService(
            updatedRequirement,
            requestID,
            service.serviceOfferingID,
            bundleData.bundleID,
            navigate
          );
        });
    
        // Batch all API calls
        const results = await Promise.all(servicePromises);                
    
        setWorkRequirement({initialWorkRequirement});
        return results;
      } catch (error) {
        console.error('Failed to save bundles:', error);
        // Handle error (e.g., show notification)
        throw error;
      }
  }
  const addService = async () => {
    
    const selectedServiceIDs = selectedServices.map(service => service.serviceOfferingID);
    
    // WorkOrder/Estimate Flow: Allow duplicates, pure "add" operation (no removal)
    if (isAllowDuplicatesFlow) {
      try {
        setLoading(true);
        
        // Add all selected services (duplicates allowed)
        await Promise.all(
          selectedServiceIDs.map(serviceID => saveWorkRequirement(serviceID, 0, navigate))
        );
        
        toast.success("Services added successfully.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
        handleCloseServiceDlg();
      } catch (error) {
        console.error("Error adding services:", error);
        toast.error("Failed to add services.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
      } finally {
        setLoading(false);
        fetchWorkRequirements(requestID);
        handleClearSearch();
        setSelectedServices([]); // Clear selection for next add
      }
    } else {
      // Assessment Flow: Prevent duplicates, sync operation (add new + remove unselected)
      const existingServiceMap = workRequirementList.filter(x => x.bundleID === 0 && x.subServiceID > 0).reduce((acc, item) => {
        acc[item.subServiceID] = item.workReqID;
        return acc;
      }, {});
    
      const existingServiceIDs = Object.keys(existingServiceMap).map(Number);
    
      // Find services to add
      const servicesToAdd = selectedServiceIDs.filter(id => !existingServiceIDs.includes(id));
    
      // Find services to remove (subServiceIDs not in selected list)
      const servicesToRemove = existingServiceIDs.filter(id => !selectedServiceIDs.includes(id));
    
      try {
        setLoading(true);
        // Add new services
        await Promise.all(
          servicesToAdd.map(serviceID => saveWorkRequirement(serviceID, 0, navigate))
        );
    
        // Remove unselected services using their workReqID
        await Promise.all(
          servicesToRemove.map(subServiceID => {
            const workReqID = existingServiceMap[subServiceID];
            return DeleteWorkRequirement(workReqID,requestID,navigate);
          })
        );
        
        toast.success(workRequirementList.length> 0? "Services updated successfully.": "Services added successfully.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
        handleCloseServiceDlg();
      } catch (error) {
        console.error("Error updating services:", error);
        toast.error("Failed to update services.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
      } finally {
        setLoading(false);
        fetchWorkRequirements(requestID);
        handleClearSearch();
      }
    }
  };
  const addBundle = async () => {
    // Bundles: ALWAYS use sync behavior (prevent duplicates) for ALL flows
    // Bundles are templates/packages, not instances - duplicates don't make sense
    
    const existingBundleMap = workRequirementList.filter(x => x.bundleID>0).reduce((acc, item) => {
      acc[item.bundleID] = item.workReqID;
      return acc;
    }, {});
  
    const existingBundleIDs = Object.keys(existingBundleMap).map(Number);
    const selectedBundleIDs = selectedBundles.map(bundle => bundle.bundleID);
  
    // Find Bundles to add (not already in work requirements)
    const bundlesToAdd = selectedBundles.filter(bundle => !existingBundleIDs.includes(bundle.bundleID));
  
    // Find Bundles to remove (bundleIDs not in selected list)
    const bundlesToRemove = existingBundleIDs.filter(id => !selectedBundleIDs.includes(id));
  
    try {
      setLoading(true);
      
      // Add new bundles - pass full bundle objects with services
      await Promise.all(
        bundlesToAdd.map(bundle => saveWorkRequirementBundle(bundle))
      );
  
      // Remove unselected bundles using their workReqID
      await Promise.all(
        bundlesToRemove.map(bundleID => {
          const workReqID = existingBundleMap[bundleID];
          return handleWorkRequirementBundleDelete(workReqID,bundleID,requestID,navigate);
        })
      );      
      
      toast.success(workRequirementList.length> 0? "Bundle updated successfully.": "Bundle added successfully.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
      });
      handleCloseBundleDlg();
    } catch (error) {
      console.error("Error updating Bundles:", error);
      toast.error("Failed to update Bundles.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
      });
    } finally {
      setLoading(false);
      fetchWorkRequirements(requestID);
    }
  };  
  const handleWorkRequirementToggle = (index,value) => {    
    setOpenService((prev) => ({        
      ...prev,
      [index]: !value,
    }));
  };

  const handleToggleBundle = (index,value) => {    
    setOpenBundle((prev) => ({        
      ...prev,
      [index]: !value,
    }));
  };

  const ResetServicesAndBundlesCollapse = () =>{
    setOpenService(false); 
    setOpenBundle(false);     
  }

  const ResetWorkRequirement = () =>{
    setWorkRequirementList([]);
    setWorkRequirement(initialWorkRequirement);
    setSelectedBundles([]);
    setSelectedServices([]);
    sf([]);
  }

  useEffect(()=>{
    if (localSearch.length > 2) {
      const timer = setTimeout(() => {
        setSearchText(localSearch);
        setPageNumber(1);
        setHasMore(true);
        fetchServices(true);
      }, 500);

      return () => clearTimeout(timer);
    } else if (localSearch.length === 0) {
      setServiceList(serviceListRef.current);
      setHasMore(true);
      setPageNumber(1);
      setSearchText("");
      fetchServices(true);
    }
  },[localSearch]);
 
  const handleLocalSearch = (event) => {
    setLocalSearch(event.target.value);    
  };

  const handleClearSearch = () => {
    setLocalSearch("");
  }
  // Memoize the service list
  const memoizedServiceList = useMemo(() => serviceList, [serviceList]); 


  useEffect(() => {
      fetchWorkRequirements(requestID).then(() => {
        fetchServices(true);
        fetchBundles();
      });
    }, []);
  
    useEffect(() => {
      if (serviceRequest?.jobSiteID > 0)
        fetchPropertyAreas(serviceRequest?.jobSiteID);
    }, [serviceRequest?.jobSiteID]);
  
    useEffect(() => {
      if (workRequirementList?.length > 0) {
        const fetchAll = async () => {
          await Promise.all(
            workRequirementList.map(item => fetchAttachments(item.workReqID))
          );
        };
    
        fetchAll();
      }
    }, [workRequirementList]);
  
    const handleUploadAttachment = async (workReqID) =>{    
      for(var i = 0; i<f.length; i++){    
        const file = f[i]; 
        if (!file) {              
          return;
        }   
        
        const formData = new FormData();
        formData.append('file', file);                   
        formData.append('EntityType', 'WR');       
        formData.append('EntityID', workReqID);      
        formData.append('MediaType', 'Attachment');      
        try {
          setLoading(true) ;
          let data = await SaveAttachments(formData,navigate);       
          if (data && !data.isError) { 
            fetchAttachments(workReqID); // Refresh list          
            toast.success(data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
                theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
              });       
          } else {                  
            toast.error(data.message || 'Failed to upload the file.', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
               theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
              });
          }
        } catch (error) {
          console.log('An error occurred while uploading the file. Please try again.');
        }finally{
          setLoading(false); 
          sf([]);       
        } 
      }            
    };
    
    const showConfirmationAttachmentDelete = (mediaID, workReqID) => {
      MySwal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        showCancelButton: true,
       confirmButtonText: 'Yes, delete it!',
       cancelButtonText: 'No, keep it',
     width: '390px', 
     padding: '1rem',
      focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', 
      customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
  }).then((result) => {
        if (result.isConfirmed) {
          // Perform delete action here
          handleDeleteFile(mediaID, workReqID);        
        }
      });
    };
  
    const handleDeleteFile = async (mediaID, workReqID) => {
      try {
        setLoading(true);
        const data = await DeleteAttachment('Attachment','WR',workReqID,mediaID, navigate);
        if (data && data.status === 200 && data.ok) { 
          fetchAttachments(workReqID); // Refresh list                
          toast.success("Attachment deleted successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });       
        } else {                  
          toast.error('Failed to deleted the file.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
        }      
      } catch (err) {
        console.error("Delete error", err);
      }finally{
        setLoading(false);
      }
    };
    
    const fetchAttachments = async (workReqID) => {
      try {
        const data = await GetAttachments('Attachment','WR',workReqID,0, navigate);
        setAttachmentMap(prev => ({ ...prev, [workReqID]: data }));
      } catch (err) {
        console.error("Fetch error", err);
      }
    };
  
    const handleDownloadAttachment = async (fileName,entityID,entityType) => {        
        try {
          // Call the service function to fetch the file data
          setLoading(true) ;
          const response = await DownloadAttachments('Attachment', 'WR', entityID, fileName, navigate);
      
          if (response && response.size > 0) {
            // Check if the response contains valid data
            //const blob = new Blob([response], { type: response.type || 'application/octet-stream' });
      
            // Use file-saver to trigger a download in the browser
            saveAs(response, fileName);
            
              toast.success(`File downloaded successfully: ${fileName}`, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                 theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
                });                               
          } else {       
              toast.error(`No data received for the requested file.`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                  theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
                });               
          }
        } catch (error) {
          console.error('Error downloading the file:', error);
        }finally{
          setLoading(false);
        }
      };


    const getBudgetedSummary = async (bundleID, workReqID, entityID) => {
      try {
        const data = await GetBudgetedSummary(0, entityID, 0, navigate);
        setBudgettedSummary(data);
      } catch (error) {
        console.error("Error fetching budgeted summary:", error);
      }
    }
  //#endregion handlers

  const AddServiceProps ={ 
    open:openServiceDlg,
    handleServiceClose:handleCloseServiceDlg,      
    serviceList: memoizedServiceList,
    loadingRecords,        
    localSearch,
    handleLocalSearch,
    handleClearSearch,
    fetchServices,
    selectedServices,
    setSelectedServices, 
    addService, 
  }

  const AddBundleProps ={
    open:openBundleDlg,
    handleBundleClose:handleCloseBundleDlg,
    bundleList,
    fetchBundles,
    selectedBundles,
    setSelectedBundles,
    addBundle,
  }

  const AttachmentProps = {
    open:openWRUploadDlg,
    handleClose:handleCloseWRUploadDlg,
    files: uploadFiles,
    setFiles : setUploadFiles,
    sf,
    f
  }

  const LineItemTotalProps={
    budgettedSummary,
    budgettedSummaryService,
    setBudgettedSummaryService,
    budgettedSummaryBundle,
    getBudgetedSummary,
  }

  const WorkRequirementsProps = {
      handleOpenBundleDlg: handleOpenBundleDlg,
      handleOpenServiceDlg: handleOpenServiceDlg,
      workRequirementList,
      openService,
      openBundle,
      handleWorkRequirementToggle,
      handleToggleBundle,
      handleAddInstruction,
      handleRemoveInstruction,
      handleToggleAlert,
      newInstruction,
      setNewInstruction,
      handleWorkRequirementChange,
      handleChange,
      UpdateWorkRequirement,
      PropertyAreas,
      fetchPropertyAreas,
      handleOpenWorkRequirementUploadDlg,
      handleUploadAttachment,
      showConfirmationAttachmentDelete,
      fetchAttachments,
      handleDownloadAttachment,
      attachmentMap,
      showConfirmationWorkRequirementDelete,
      showConfirmationBundleDelete,
      ResetServicesAndBundlesCollapse,
      ResetWorkRequirement,
      toast, 
      setLoading,
      fetchWorkRequirements,
      requestID,
      LineItemTotalProps,
  }  

  return(
  {
    AddServiceProps,
    AddBundleProps,
    WorkRequirementsProps,
    AttachmentProps, 
  });

}